// answers of page scripts and messages that survive a reload.
import { toast, type ToastOptions } from './toast.ts';

/** A message kept for the next page. */
interface Flash {
  msg: string;
  opt: ToastOptions;
  t: number;
}

/** What a post sent with X-DS-Action answers (ActionOutcomeFilter); older answers have neither field. */
export interface ActionAnswer {
  ok?: boolean;
  message?: string;
  messages?: { text: string; type?: ToastOptions['type'] }[];
}

// a message that must survive the reload a page script does right after showing it (the sweetAlert bridge)
let lastToast: Flash | null = null;
/**
 * T-127: the answer of a post sent with header X-DS-Action ({ ok, messages } / { ok: false, message }, ActionOutcomeFilter).
 * A refusal shows now and returns false (stay on the page, the input kept); a success keeps its first message for the next
 * page (the caller navigates) and returns true. Anything else (an old answer) counts as a success with no message.
 */
export function answer(data: ActionAnswer | null | undefined): boolean {
  if (data && data.ok === false) {
    toast(data.message || 'این کار انجام نشد. صفحه را تازه کنید و دوباره امتحان کنید.', { type: 'danger' });
    return false;
  }
  const m = data?.messages?.[0];
  if (m) flash(m.text, { type: m.type || 'success' });
  return true;
}
export function flash(msg: string, opt: ToastOptions = {}): void {
  lastToast = { msg, opt, t: Date.now() };
}
addEventListener('pagehide', () => {
  if (lastToast && Date.now() - lastToast.t < 3000) {
    try {
      sessionStorage.setItem('ds-flash', JSON.stringify(lastToast));
    } catch {
      /* storage blocked */
    }
  }
});
export function showFlash(): void {
  try {
    const raw = sessionStorage.getItem('ds-flash');
    if (!raw) return;
    sessionStorage.removeItem('ds-flash');
    const f = JSON.parse(raw) as Flash;
    if (Date.now() - f.t < 15000) toast(f.msg, f.opt);
  } catch {
    /* storage blocked or malformed */
  }
}
